import { Link } from 'react-router-dom';


const PromotionBanner = ({ promotions, isDarkMode }) => {
  if (!promotions || promotions.length === 0) return null;

  return (
    <div className="mb-0 md:mb-8">
      <div className="hidden gap-4 md:grid md:grid-cols-3">
        {promotions.slice(0, 3).map((promo) => (
          <Link
            key={promo.id}
            to={promo.link}
            target="_blank"
            className="block h-[150px] rounded-lg overflow-hidden"
          >
            <img
             src={promo.image}
              alt="Promotion"
              className="object-cover w-full h-full rounded-lg"
            />
          </Link>
        ))}
      </div>

      {/* Custom CSS for dots */}
      <style jsx>{`
        :global(.custom-dots) {
          bottom: -25px !important;
        }
        :global(.custom-dots li button) {
          background: #d1d5db !important;
          opacity: 0.5;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
        :global(.custom-dots li.slick-active button) {
          opacity: 1;
          background: #22c55e !important;
          width: 24px;
          border-radius: 12px;
        }
      `}</style>
    </div>
  );
};

export default PromotionBanner;